import { isEqual } from 'lodash';
import { debugLogger } from '../../debug/DebugLogger';

const log = debugLogger.scope('filters');

export const updateActiveFiltersFromLazyState = (
  oldActiveFilters,
  lazyState,
  dataset
) => {
  const newActiveFilters =
    oldActiveFilters === null ? {} : { ...oldActiveFilters };
  Object.keys(lazyState.filters).forEach((key) => {
    const column = dataset?.items.find(({ name }) => name === key);
    if (column?.filterParam) {
      const filterParam = column.filterParam;
      const newValue = lazyState.filters[key].constraints[0].value;
      if (newValue === null) {
        if (newActiveFilters[filterParam]) {
          delete newActiveFilters[filterParam];
        }
      } else {
        const newMatchMode = lazyState.filters[key].constraints[0].matchMode;
        newActiveFilters[filterParam] = {
          [newMatchMode]: newValue,
        };
      }
    }
  });
  if (isEqual(newActiveFilters, oldActiveFilters)) {
    return oldActiveFilters;
  }

  /** @debugFeature filters Logs activeFilters rebuilt from a grid lazyState change — old and new filter maps. */
  log('activeFilters updated from lazyState', () => ({
    oldActiveFilters,
    newActiveFilters,
  }));

  return newActiveFilters;
};
